import React from 'react';
import { movedToSavedLang } from './i18n';
import ReactDOM from 'react-dom/client';
import './styles/vaul.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

declare global {
  interface Window {
    /** Used by scripts/prerender.js: the page has its title and its data (no loading placeholders). */
    __pageReady?: () => boolean;
  }
}

const rootEl = document.getElementById('root') as HTMLElement;
// A pre-rendered page was saved "ready"; the live app must say so itself.
delete document.documentElement.dataset.seoReady;

function isReady(container: HTMLElement): boolean {
  return document.documentElement.dataset.seoReady === '1' && !container.querySelector('.animate-pulse');
}
window.__pageReady = () => isReady(document.getElementById('root') as HTMLElement);

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Pre-rendered page (docs/seo-plan.md): keep the ready-made page on screen and
// build the live app beside it, unseen; swap when the live app has its data
// (at most 5 seconds), so visitors never see an empty page or placeholders in
// between. A page in the wrong language (moved to the visitor's saved
// language) is dropped straight away.
const prerendered = rootEl.hasChildNodes() && !movedToSavedLang;
if (!prerendered) {
  rootEl.replaceChildren();
  ReactDOM.createRoot(rootEl).render(app);
} else {
  const live = document.createElement('div');
  live.style.cssText = 'position:absolute;top:0;left:0;right:0;visibility:hidden;pointer-events:none';
  live.setAttribute('aria-hidden', 'true');
  rootEl.after(live);
  ReactDOM.createRoot(live).render(app);
  const started = Date.now();
  const timer = window.setInterval(() => {
    if (!isReady(live) && Date.now() - started < 5000) return;
    window.clearInterval(timer);
    rootEl.remove();
    live.id = 'root';
    live.removeAttribute('style');
    live.removeAttribute('aria-hidden');
  }, 50);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
